import React, { useContext } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';

const CartItems = () => {

    const {getTotalCartItems, getTotalCartAmount,all_product, cartItems, removeFromCart } = useContext(ShopContext);

    return (
        <div className='cartitems'>

            <div className="cartitems-formate-main">
                <p>Product</p>
                <p>Title</p>
                <p>Price</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>

            <hr />

            {all_product.map((e) => {

                if (cartItems[e.id] > 0) {
                    return (
                        <div key={e.id}>
                            <div className="cartitems-formate cartitems-formate-main">
                                <img
                                    src={e.image}
                                    alt=""
                                    className='carticon-product-icon'
                                />

                                <p>{e.name}</p>

                                <p>${e.new_price}</p>

                                <button className='cartitems-quantity'>
                                    {cartItems[e.id]}
                                </button>

                                <p>
                                    ${e.new_price * cartItems[e.id]}
                                </p>

                                <img
                                    src={remove_icon}
                                    onClick={() => removeFromCart(e.id)}
                                    alt=""
                                />
                            </div>
                            <hr />
                        </div>
                    );
                }

                return null;
            })}
            <div className="cart">

    <div className="cartitems-total">

        <h1>Cart Total</h1>

        <div>

            <div className="cartitems-total-item">
                <p>Subtotal</p>
                <p>${getTotalCartAmount()}</p>
            </div>

            <hr />

            <div className="cartitems-total-item">
                <p>Shipping fee</p>
                <p>Free</p>
            </div>

            <hr />

            <div className="cart-itesm-total">
                <h3>Total</h3>
                <h3>${getTotalCartAmount()}</h3>
            </div>

        </div>

        <button>PROCEED TO CHECKOUT</button>

    </div>


    <div className="cartitems-promocode">

        <p>
            If you have a promocode, Enter it here
        </p>

        <div className="cartites">
            <input
                type="text"
                placeholder="Enter Your Promocode"
            />

            <button>Submit</button>
        </div>

    </div>

</div>

        </div>
    );
};

export default CartItems;